<template>
    <div class="rn-popup-modal placebid-modal-wrapper modal fade bg-dark/50" id="placebidModal" tabindex="-1" aria-hidden="true">
        <button type="button" class="btn-close absolute top-4 right-4 bg-transparent border-0 text-white text-2xl hover:text-primary" data-bs-dismiss="modal" aria-label="Close"><i class="feather-x"/></button>
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content bg-[var(--background-color-1)] p-6 rounded-lg">
                <div class="modal-header border-b border-[var(--color-border)] pb-4 mb-4">
                    <h3 class="modal-title text-xl font-semibold text-white">Place a bid</h3>
                </div>
                <div class="modal-body">
                    <p class="text-gray-400 mb-4">You are about to purchase This Product Form Nuron</p>
                    <div class="placebid-form-box">
                        <h5 class="title text-white font-medium mb-3">Your bid</h5>
                        <div class="bid-content">
                            <div class="bid-content-top mb-4">
                                <div class="bid-content-left flex items-center gap-3">
                                    <input id="value" type="text" name="value" class="flex-1 p-3 bg-[var(--background-color-4)] border border-[var(--color-border)] rounded text-white focus:border-primary focus:outline-none">
                                    <span class="text-gray-400">wETH</span>
                                </div>
                            </div>
                            <div class="bid-content-mid flex justify-between text-sm">
                                <div class="bid-content-left text-gray-400 space-y-2">
                                    <span class="block">Your Balance</span>
                                    <span class="block">Service fee</span>
                                    <span class="block">Total bid amount</span>
                                </div>
                                <div class="bid-content-right text-white space-y-2 text-right">
                                    <span class="block">9578 wETH</span>
                                    <span class="block">10 wETH</span>
                                    <span class="block text-primary font-semibold">9588 wETH</span>
                                </div>
                            </div>
                        </div>
                        <div class="bit-continue-button mt-6 space-y-3">
                            <router-link to="/connect" class="btn btn-primary w-full block text-center py-3 rounded">Place a bid</router-link>
                            <button type="button" class="btn btn-primary-alta w-full py-3 rounded" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PlacebidModal'
    }
</script>